export const URL = 'https://backend.sungatesystems.com'
